import { Component, computed, OnInit, Signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import {
  EarlyAccessSelectionComponent
} from '@app/app/components/settings/early-access-selection/early-access-selection.component';
import { EarlyAccessFeatureService } from '@app/app/components/settings/early-access/early-access-feature.service';
import { EarlyAccessFeature } from '@app/app/components/settings/early-access/early-access-feature';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import {
  LendioAngularMaterialThemeService
} from "@app/app/components/lendio-angular-material-theme/lendio-angular-material-theme.service";

@Component({
  selector: 'app-early-access',
  standalone: true,
  imports: [MatCardModule, EarlyAccessSelectionComponent, MatButtonModule, MatProgressSpinnerModule, CommonModule],
  templateUrl: './early-access.component.html',
  styleUrl: './early-access.component.scss'
})
export class EarlyAccessComponent implements OnInit {
  features: Signal<EarlyAccessFeature[]> = computed(() => this._earlyAccessFeatureService.earlyAccessFeatures());
  featuresCopy: EarlyAccessFeature[] = this.features().map((feature => ({...feature})));
  private _savingChanges = false;

  constructor(private _earlyAccessFeatureService: EarlyAccessFeatureService, private _themeService: LendioAngularMaterialThemeService) { }

  ngOnInit() {
    if (this._themeService.enabledCurrentValue) {
      this._earlyAccessFeatureService.disableNewFeatureBadge();
    }
  }

  get noChangesToSave(): boolean {
    return JSON.stringify(this.features()) === JSON.stringify(this.featuresCopy);
  }

  get savingChanges(): boolean {
    return this._savingChanges;
  }

  set savingChanges(state: boolean) {
    this._savingChanges = state;
  }

  saveFeatureChanges(): void {
    this._earlyAccessFeatureService.triggerFeatureUpdates();
    this.featuresCopy = this.features().map((feature => ({...feature})));
    this.savingChanges = true;
    setTimeout(() => this.savingChanges = false, 1000);
  }
}
